import {
    ADD_BLISTER_PACK_REQUEST,
    ADD_BLISTER_PACK_SUCCESS,
    ADD_BLISTER_PACK_FAILURE
} from "../../../constants"

import {
    add_blister_pack, update_blister_pack,
    delete_blister_pack, print_dispense_blister,
    patient_checkrefills,
    add_medrx_notes,
    add_billing,
    print_label_dispense_blister,
    update_blister_log,
    add_vials_pack,
    update_vials_pack,
    update_vials_packlogs,
    add_sMedication_pack,
    update_sMedication_pack,
    update_sMedication_log
} from "../../../../networking/urlEndPoints"

import {
    fetchBlisterDailyPackList,
    fetchBlisterPackPatientList,
    fetchBlisterPacksList,
    fetchBlisterPacksOnShelfList,
    fetchMEdicationDailyPackList,
    fetchVialsDailyPackList
} from "./patientBlisterPackList"

import { PreviewPdf, showToast } from "../../../../utils/helper/helper"

import { exportBlisterToExcel } from "../../../../screens/pharmacy/blisters/blisterPacksOnShelf"
import { toast } from "react-toastify"

import Axios from "../../../../networking/intraceptor"
import * as routeName from '../../../../routes/routeName'
import * as path from '../../../../networking/urlEndPoints'

// -----------------------Add request action ------------------------
export const addPatientBlisterPackRequest = (types) => ({
    type: ADD_BLISTER_PACK_REQUEST,
    types: types
})

// -----------------------Success action ------------------------

export const addPatientBlisterPackSuccess = (data, types) => ({
    type: ADD_BLISTER_PACK_SUCCESS,
    payload: data,
    types: types
})

// -----------------------Failure action ------------------------

export const addPatientBlisterPackFailure = (error, types) => ({
    type: ADD_BLISTER_PACK_FAILURE,
    payload: error,
    types: types
})

// ------------------------Add Blister Pack----------------------------

export const AddBlisterPack = (type, formdata, id, setShowModal, setShowToast) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {
            const requestData = {
                patient_id: id,
                recurrence_day_type: formdata.recurrence_day_type,
                recurrence_day: formdata.recurrence_day_type === 'custom' ? formdata.r_days : formdata.recurrence_day,
                rx_need_to_bill: formdata.rx_need_to_bill,
                deductibles: formdata.deductibles,
                note: formdata.note,
                recurrence_weekday: formdata.recurrence_weekday,
                start_date: formdata.date,
                facility: formdata.facility
            }

            const response = await Axios.post(`${add_blister_pack}`, requestData)
            if (response?.status === 200) {

                dispatch(addPatientBlisterPackSuccess(response?.data, type))

                if (typeof setShowModal === 'function') {
                    setShowModal((prevStat) => ({ ...prevStat, addBlisterPackModal: false }))
                    document.body.style.overflow = 'auto'
                }

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, showToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, showToast: false }))
                    }, 2000);
                }

            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {

                const errorMessage = error?.response?.data?.data?.error === 'This patient entry has reached the allowed limit.'

                if (errorMessage) {
                    toast.error('2 packs are already added for this patient. Please contact admin.')
                }
                else if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, errorToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, errorToast: false }))
                    }, 2000);
                }

                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}


// ------------------------Update Blister Pack----------------------------

export const UpdateBlisterPack = (type, requestData, setShowModal, setShowToast, paginationNumber, formData) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {
            const response = await Axios.post(`${update_blister_pack}`, requestData)
            if (response?.status === 200) {

                dispatch(addPatientBlisterPackSuccess(response?.data, type))

                if (typeof setShowModal === 'function') {
                    setShowModal((prevStat) => ({ ...prevStat, updateBlisterlist: false }))
                    document.body.style.overflow = 'auto'
                }

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, showToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, showToast: false }))
                    }, 2000);
                }

                const params = {
                    page: paginationNumber,
                    no_of_records: 25
                };

                if (formData.route) params.route = formData.route;
                if (formData.search) params.search = formData.search;
                if (formData.day) params.rec_day = formData.day.match(/\d+/)[0];
                if (formData.weekday) params.rec_weekday = formData.weekday;
                if (formData.facility) params.facility = formData.facility;
                if (formData.startDate) params.from_date = formData.startDate;
                if (formData.endDate) params.to_date = formData.endDate;

                dispatch(fetchBlisterPacksList('blister_packs_list', params))

            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, errorToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, errorToast: false }))
                    }, 2000);
                }

                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}

// ------------------------Delete Blister Pack------------------------------

export const DeleteBlisterPack = (type, formdata, id, setShowModal, setShowToast, paginationNumber, location, urlEndPoint) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {

            const endpoint = urlEndPoint ? `${urlEndPoint}/${id}` : `${delete_blister_pack}/${id}`;
            const response = await Axios.post(endpoint)

            if (response?.status === 200) {

                dispatch(addPatientBlisterPackSuccess(response?.data, type))

                if (typeof setShowModal === 'function') {
                    setShowModal((prevStat) => ({ ...prevStat, deleteBlisterModal: false }))
                    document.body.style.overflow = 'auto'
                }

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, showToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, showToast: false }))
                    }, 2000);
                }

                const params = {
                    page: paginationNumber,
                    no_of_records: 10
                }

                if (location.pathname === routeName.pharmacy_blister_pack_on_shelf) {
                    dispatch(fetchBlisterPacksOnShelfList('blister_packs_on_shelf_list', formdata, paginationNumber))

                } else if (location.pathname === routeName.pharmacy_vials_packs) {
                    dispatch(fetchBlisterPacksList('Vials_pack_list', params, path.vials_patient_pack))
                } else if (location.pathname === routeName.pharmacy_speciality_medication_packs) {
                    dispatch(fetchBlisterPacksList('medication_pack_list', params, path.sMedication_pack_list))
                } else {
                    if (formdata.search) params.search = formdata.search;
                    if (formdata.route) params.route = formdata.route;
                    if (formdata.day) params.rec_day = formdata.day.match(/\d+/)[0];
                    if (formdata.weekday) params.rec_weekday = formdata.weekday;
                    if (formdata.facility) params.facility = formdata.facility;
                    if (formdata.startDate) params.from_date = formdata.startDate;
                    if (formdata.endDate) params.to_date = formdata.endDate;
                    dispatch(fetchBlisterPacksList('blister_packs_list', params))
                }

            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, errorToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, errorToast: false }))
                    }, 2000);
                }

                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}


export const DeleteBlisterPatient = ({ patientID, setShowModal, type, formData, page, billedType }) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {

            const endpoint = 'delete-blister-dailypack-patient';
            const response = await Axios.post(endpoint, { patient_id: patientID })

            if (response?.status === 200) {
                dispatch(addPatientBlisterPackSuccess(response?.data, type))
                if (typeof setShowModal === 'function') {
                    setShowModal((prevStat) => ({ ...prevStat, deleteBlisterPatient: false }))
                    document.body.style.overflow = 'auto'
                }

                const params = {
                    page: page,
                    no_of_records: 25
                };

                if (formData.route) params.route = formData.route;
                if (formData.search) params.search = formData.search;
                if (formData.day) params.rec_day = formData.day.match(/\d+/)[0];
                if (formData.weekday) params.rec_weekday = formData.weekday;
                if (formData.facility) params.facility = formData.facility;
                if (formData.startDate) params.from_date = formData.startDate;
                if (formData.endDate) params.to_date = formData.endDate;
                if (billedType) params.billed = billedType;

                dispatch(fetchBlisterDailyPackList('blister_daily_pack_list', params))
            }

        } catch (error) {
            if (error?.response) {
                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}


export const DeleteVialsPatient = ({ patientID, setShowModal, type, formData, page, billedType }) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {

            const endpoint = 'delete-vials-daily-packlogs';
            const response = await Axios.post(endpoint, { patient_id: patientID })

            if (response?.status === 200) {
                dispatch(addPatientBlisterPackSuccess(response?.data, type))

                if (typeof setShowModal === 'function') {
                    setShowModal((prevStat) => ({ ...prevStat, deleteBlisterPatient: false }))
                    document.body.style.overflow = 'auto'
                }

                const params = {
                    page: page,
                    no_of_records: 25
                };

                if (formData.route) params.route = formData.route;
                if (formData.search) params.search = formData.search;
                if (formData.day) params.rec_day = formData.day.match(/\d+/)[0];
                if (formData.weekday) params.rec_weekday = formData.weekday;
                if (formData.facility) params.facility = formData.facility;
                if (formData.startDate) params.from_date = formData.startDate;
                if (formData.endDate) params.to_date = formData.endDate;
                if (billedType) params.billed = billedType;

                dispatch(fetchVialsDailyPackList('vials_daily_pack_list', params))
            }

        } catch (error) {
            if (error?.response) {
                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}

export const DeleteMedicationPatient = ({ patientID, setShowModal, type, formData, page, billedType }) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {

            const endpoint = 'delete-medication-daily-packlogs';
            const response = await Axios.post(endpoint, { patient_id: patientID })

            if (response?.status === 200) {
                dispatch(addPatientBlisterPackSuccess(response?.data, type))

                if (typeof setShowModal === 'function') {
                    setShowModal((prevStat) => ({ ...prevStat, deleteBlisterPatient: false }))
                    document.body.style.overflow = 'auto'
                }

                const params = {
                    page: page,
                    no_of_records: 25
                };

                if (formData.route) params.route = formData.route;
                if (formData.search) params.search = formData.search;
                if (formData.day) params.rec_day = formData.day.match(/\d+/)[0];
                if (formData.weekday) params.rec_weekday = formData.weekday;
                if (formData.facility) params.facility = formData.facility;
                if (formData.startDate) params.from_date = formData.startDate;
                if (formData.endDate) params.to_date = formData.endDate;
                if (billedType) params.billed = billedType;

                dispatch(fetchMEdicationDailyPackList('medication_daily_pack_list', params))
            }

        } catch (error) {
            if (error?.response) {
                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}

// --------------------------------Print All Medicine Data in Blister Pack page list while opening the patient medication modal -------------------------------
export const PrintAllDispenseData = (type, patient_id, dispense) => {
    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))

        try {
            const uploadData = {
                patient_id: patient_id,
                rxlabeltoprint: dispense
            }
            const response = await Axios.post(`${print_dispense_blister}`, uploadData)

            if (response?.status === 200) {
                PreviewPdf(response?.data?.data)
                dispatch(addPatientBlisterPackSuccess(response?.data, type))

            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}

// --------------------------------Update the  Refills In Patient Medication Detail-------------------------------

export const PatientCheckRefills = (type, is_checked, c_type, patient_id, rxnum, setShowToast) => {
    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))

        try {
            const uploadData = {
                is_checked: is_checked,
                ctype: c_type,
                patient_id: patient_id,
                rxnum: rxnum
            }
            const response = await Axios.post(`${patient_checkrefills}`, uploadData)

            if (response?.status === 200) {

                dispatch(addPatientBlisterPackSuccess(response?.data, type))

                if (typeof setShowToast === 'function') {
                    setShowToast((prevstat) => ({ ...prevstat, showToast: true }))
                    setTimeout(() => {
                        setShowToast((prevstat) => ({ ...prevstat, showToast: false }))
                    }, 2000);
                }

            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {

                if (typeof setShowToast === 'function') {
                    setShowToast((prevstat) => ({ ...prevstat, errorToast: true }))
                    setTimeout(() => {
                        setShowToast((prevstat) => ({ ...prevstat, errorToast: false }))
                    }, 2000);
                }

                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}

// --------------------------------Add patient note-------------------------------

export const AddPatientNote = (type, requestData, setShowModal, setShowToast) => {
    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))

        try {
            const response = await Axios.post(`${add_medrx_notes}`, requestData)

            if (response?.status === 200) {

                dispatch(addPatientBlisterPackSuccess(response?.data, type))

                if (typeof setShowToast === 'function') {
                    setShowModal((prevstat) => ({ ...prevstat, addNoteModal: false }))

                    setShowToast((prevstat) => ({ ...prevstat, showToast: true }))
                    setTimeout(() => {
                        setShowToast((prevstat) => ({ ...prevstat, showToast: false }))
                    }, 2000);
                }

            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {

                if (typeof setShowToast === 'function') {
                    setShowToast((prevstat) => ({ ...prevstat, errorToast: true }))
                    setTimeout(() => {
                        setShowToast((prevstat) => ({ ...prevstat, errorToast: false }))
                    }, 2000);
                }

                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}

export const handleAddBlisterPackNote = ({ type, requestData, setShowModal, formData, pageNumber }) => {
    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {
            // const response = await Axios.post(`add-blister-pack-note`, requestData)
            const response = await Axios.post(`save-blister-pack-note`, requestData)

            if (response?.status === 200) {
                dispatch(addPatientBlisterPackSuccess(response?.data, type))
                showToast('Note added successfully', 'success')
                setShowModal((prevStat) => ({ ...prevStat, addPackOnShelfNotes: false }))
                dispatch(fetchBlisterPacksOnShelfList('blister_packs_on_shelf_list', formData, pageNumber))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                const errorMessage = error?.response?.data?.data?.error || 'Something went wrong'
                showToast(errorMessage, 'error')
                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}

export const handleDeleteBlisterPackNote = ({ type, formData, pageNumber, id }) => {
    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {
            // const response = await Axios.post(`add-blister-pack-note`, requestData)
            const response = await Axios.delete(`delete-blister-pack-note/${id}`)

            if (response?.status === 200) {
                dispatch(addPatientBlisterPackSuccess(response?.data, type))
                showToast('Note deleted successfully', 'success')
                dispatch(fetchBlisterPacksOnShelfList('blister_packs_on_shelf_list', formData, pageNumber))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                const errorMessage = error?.response?.data?.data?.error || 'Something went wrong'
                showToast(errorMessage, 'error')
                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}

// --------------------------------Update patient note-------------------------------

export const AddBillingNote = (type, requestData, setShowModal, setShowToast) => {
    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))

        try {
            const response = await Axios.post(`${add_billing}`, requestData)

            if (response?.status === 200) {

                dispatch(addPatientBlisterPackSuccess(response?.data, type))

                if (typeof setShowToast === 'function') {
                    setShowModal((prevstat) => ({ ...prevstat, patientNoteModal: false }))

                    setShowToast((prevstat) => ({ ...prevstat, showToast: true }))
                    setTimeout(() => {
                        setShowToast((prevstat) => ({ ...prevstat, showToast: false }))
                    }, 2000);
                }

            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {

                if (typeof setShowToast === 'function') {
                    setShowToast((prevstat) => ({ ...prevstat, errorToast: true }))
                    setTimeout(() => {
                        setShowToast((prevstat) => ({ ...prevstat, errorToast: false }))
                    }, 2000);
                }

                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}

// --------------------------------Print label Data-------------------------------

export const PrintLabelsData = (type, uploadData) => {
    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))

        try {

            const response = await Axios.post(`${print_label_dispense_blister}`, uploadData)

            if (response?.status === 200) {
                PreviewPdf(response?.data?.data)
                dispatch(addPatientBlisterPackSuccess(response?.data, type))

            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}


// ----------------------------------Update Daily Blister Pack---------------------------

// export const UpdateBlisterDailyPack = (type, formdata, id, setShowModal, setShowToast, paginationNumber) => {

//     return async (dispatch) => {
//         dispatch(addPatientBlisterPackRequest(type))
//         try {
//             let requestData
//             if (type === 'update_blister_daily_pack') {
//                 requestData = {
//                     pack_id: id,
//                     blister_route: formdata.route,
//                     facility: formdata.facility,
//                     deductible: formdata.deductible,
//                     rx_need_to_bill: formdata.no_of_rx_need_to_bill,
//                     note: formdata.note,
//                     prescription_billed: formdata.prescription_billed
//                 }
//             } else {
//                 requestData = {
//                     allbilled: formdata,
//                     pack_id: id,
//                 }
//             }

//             const response = await Axios.post(`${update_blister_log}`, requestData)

//             if (response?.status === 200) {
//                 dispatch(addPatientBlisterPackSuccess(response?.data, type))

//                 if (typeof setShowModal === 'function') {
//                     setShowModal((prevStat) => ({ ...prevStat, updateBlisterlist: false }))
//                     document.body.style.overflow = 'auto'
//                 }

//                 if (typeof setShowToast === 'function') {
//                     setShowToast((prevStat) => ({ ...prevStat, showToast: true }))
//                     setTimeout(() => {
//                         setShowToast((prevStat) => ({ ...prevStat, showToast: false }))
//                     }, 2000);
//                 }

//                 const params = {
//                     page: paginationNumber,
//                     no_of_records: 10
//                 }
//                 // dispatch(fetchBlisterDailyPackList('blister_daily_pack_list', params))

//             } else {
//                 throw new Error(response)
//             }
//         } catch (error) {
//             if (error?.response) {

//                 if (typeof setShowToast === 'function') {
//                     setShowToast((prevStat) => ({ ...prevStat, errorToast: true }))
//                     setTimeout(() => {
//                         setShowToast((prevStat) => ({ ...prevStat, errorToast: false }))
//                     }, 2000);
//                 }

//                 dispatch(addPatientBlisterPackFailure(error?.response, type))
//             }
//         }
//     }
// }

export const UpdateBlisterDailyPack = (type, requestData, setShowModal, setShowToast, paginationNumber, fetchType, filterParam) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {
            const response = await Axios.post(`${update_blister_log}`, requestData)

            if (response?.status === 200) {
                dispatch(addPatientBlisterPackSuccess(response?.data, type))

                if (typeof setShowModal === 'function') {
                    setShowModal((prevStat) => ({ ...prevStat, updateBlisterlist: false }))
                    document.body.style.overflow = 'auto'
                }

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, showToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, showToast: false }))
                    }, 2000);
                }

                const params = {
                    page: paginationNumber,
                    no_of_records: 10,
                    // ...filterParam,
                    ...(filterParam && typeof filterParam === 'object' ? filterParam : {}) // Safe spread
                }

                if (fetchType === 'due_date') {
                    dispatch(fetchBlisterDailyPackList('blister_daily_pack_list', params))
                }

            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, errorToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, errorToast: false }))
                    }, 2000);
                }

                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}

export const UpdateBlisterPAckOnShelf = (type, formdata, id, setShowModal, setShowToast, paginationNumber, filterParam) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {
            //console.log("bohemia"+filterParam)
            let requestData = {
                pack_id: id,
                blister_route: formdata.route,
                facility: formdata.facility,
                no_of_blister_pack: formdata.no_of_blister_pack,
                note: formdata.note,
            }
            const response = await Axios.post(`${update_blister_pack}`, requestData)

            if (response?.status === 200) {
                dispatch(addPatientBlisterPackSuccess(response?.data, type))

                if (typeof setShowModal === 'function') {
                    setShowModal((prevStat) => ({ ...prevStat, updateBlisterlist: false }))
                    document.body.style.overflow = 'auto'
                }

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, showToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, showToast: false }))
                    }, 2000);
                }

                // const params = {
                //     page: paginationNumber,
                //     no_of_records: 25,
                //     ...filterParam
                // }

                // if (type === 'update_blister_packs_on_shelf') {
                //     dispatch(fetchBlisterPacksOnShelfList('blister_packs_on_shelf_list', params))
                // }
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, errorToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, errorToast: false }))
                    }, 2000);
                }

                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}

export const BulkUpdateNOB = (type, formdata, checkblister, setShowModal, setShowToast, paginationNumber,
    setAllChecked,
    setBlister_id, setFormData) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {
            let requestData = {
                checkblister: checkblister,
                value: formdata.value,
                pin: formdata.pin,
                verification_pin: formdata.supervisor_pin
            }

            const response = await Axios.post(`${path.patient_assign_bshelfpacks}`, requestData)

            if (response?.status === 200) {
                dispatch(addPatientBlisterPackSuccess(response?.data, type))

                if (typeof setShowModal === 'function') {
                    setShowModal((prevStat) => ({ ...prevStat, updateBlisterlist: false }))
                    document.body.style.overflow = 'auto'
                }

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, showToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, showToast: false }))
                    }, 2000);
                }

                if (response?.data?.status === 1) {
                    // toast.success(response?.data?.message)
                    setAllChecked(false)
                    setBlister_id([])
                    setFormData((prevStat) => ({ ...prevStat, value: '', supervisor_pin: '', pin: '' }))

                    toast.success(
                        <div>
                            <h4>{response?.data?.message} </h4>
                        </div>,
                        {
                            position: "top-right", // Fixed at the bottom left
                            autoClose: 2000,
                            closeOnClick: true, // Allow closing on click
                            hideProgressBar: true, // Hide progress bar
                            draggable: false, // Prevent dragging the toast
                            style: {
                                background: "#fff",
                                color: "#333",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                borderRadius: "8px",
                                padding: "16px",
                                // maxWidth: "320px",
                            },
                        }
                    );

                }

                if (type === 'update_blister_packs_on_shelf') {
                    dispatch(fetchBlisterPacksOnShelfList('blister_packs_on_shelf_list', formdata, paginationNumber))
                } else {
                    dispatch(fetchBlisterPacksOnShelfList('blister_packs_on_shelf_list', formdata, paginationNumber))
                }
            }

        } catch (error) {
            if (error?.response) {

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, errorToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, errorToast: false }))
                    }, 2000);
                }
                // console.log(error?.response?.data?.data)
                if (error?.response?.data?.data?.status === 0) {
                    toast.error(
                        <div>
                            <h4>{error?.response?.data?.data?.error} </h4>
                        </div>,
                        {
                            position: "top-right", // Fixed at the bottom left
                            autoClose: 3000,
                            closeOnClick: true, // Allow closing on click
                            hideProgressBar: false, // Hide progress bar
                            draggable: false, // Prevent dragging the toast
                            style: {
                                background: "#fff",
                                color: "#333",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                borderRadius: "8px",
                                padding: "16px",
                                // maxWidth: "320px",
                            },
                        }
                    );
                }
                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}

export const UpdateBlisterOnShelfExportSheet = (type, requestData) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {

            const response = await Axios.post(`patient-exportBlister-data`, requestData)

            if (response?.status === 200) {
                dispatch(addPatientBlisterPackSuccess(response?.data, type))
                exportBlisterToExcel(response?.data?.data?.data, 'blister-pack-export')
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}

export const HandleDownloadBlisterSheet = (type, requestData) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {

            const response = await Axios.post(`/blister-sheet-pdf`, requestData)
            // const response = await Axios.post(`/patient-blister-pdf`, requestData)
            if (response?.status === 200) {
                dispatch(addPatientBlisterPackSuccess(response?.data, type));
                PreviewPdf(response?.data?.certificate)
                // // Create a blob from the PDF response
                // const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
                // // Create a URL for the blob
                // const pdfUrl = URL.createObjectURL(pdfBlob);
                // // Open the PDF in a new tab
                // const newTab = window.open(pdfUrl, '_blank');
                // if (!newTab) {
                //     alert('Popup blocked! Please allow popups for this website.');
                // }
                // // Optionally, revoke the object URL after some time
                // setTimeout(() => {
                //     URL.revokeObjectURL(pdfUrl);
                // }, 10000); // Revoke after 10 seconds
            } else {
                throw new Error(response);
            }

        } catch (error) {
            if (error?.response) {
                showToast('Got an issue while downloading PDF please try again', 'error')
                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}

export const handleDownloadBlisterSheet = (type, requestData, params, formData, pageNumber, setNoOfMedication) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {

            const response = await Axios.post(`/patient-blister-pdf`, requestData)
            if (response?.status === 200) {

                dispatch(addPatientBlisterPackSuccess(response?.data, type));
                PreviewPdf(response?.data?.certificate)

                if (response?.data?.certificate && params) {
                    dispatch(fetchBlisterPackPatientList('new-blister-patients-list', params))
                }

                if (response?.data?.certificate && formData && pageNumber) {
                    dispatch(fetchBlisterPacksOnShelfList('blister_packs_on_shelf_list', formData, pageNumber))
                }

                if (typeof setNoOfMedication === 'function') {
                    setNoOfMedication('')
                }

            } else {
                throw new Error(response);
            }

        } catch (error) {
            if (error?.response) {
                showToast('Got an issue while downloading PDF please try again', 'error')
                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}

export const handleBlisterBulkDownloadPDF = (type, formdata) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {
            const payload = {
                route: formdata.route,
                facility: formdata.facility,
                date: formdata.date,
            }
            const response = await Axios.post(`/bulk-patient-blister-pdf`, payload)
            if (response?.status === 200) {
                dispatch(addPatientBlisterPackSuccess(response?.data, type));
                const jobId = response?.data?.job_status?.id
                if (jobId) {
                    dispatch(handleBlisterBulkDownloadPDFJobStatus(jobId))
                }
            } else {
                throw new Error(response);
            }

        } catch (error) {
            if (error?.response) {
                showToast('Got an issue while downloading PDF please try again', 'error')
                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}

// ----------------------------------------------------Vials Section Start ---------------------------------------

export const handleBlisterBulkDownloadPDFJobStatus = (JobID) => {
    return async (dispatch) => {
        try {
            sessionStorage.setItem('job', JSON.stringify({ loading: true, data: null, error: null }));

            const response = await Axios.get(`/bulk-pdf-job-status?id=${JobID}`);

            if (response?.status === 200) {

                const jobData = response?.data?.job_status;

                if (jobData?.status === 'completed' && jobData?.zip_name) {
                    // const zipFileUrl = jobData.zip_name;
                    // const link = document.createElement('a');
                    // link.href = zipFileUrl;
                    // link.setAttribute('download', 'bulk-download.zip');  // Force download with custom name
                    // document.body.appendChild(link);
                    // link.click();
                    // document.body.removeChild(link);
                    // setTimeout(() => {
                    //     window.location.reload();
                    // }, 2000);
                    // sessionStorage.removeItem('job');

                }

                else if (jobData.status === 'failed') {
                    showToast('Download failed', 'error');
                }

                sessionStorage.setItem('job', JSON.stringify({ loading: false, data: response?.data, error: null }));
                return response?.data;
            } else {
                throw new Error(response);
            }
        } catch (error) {
            sessionStorage.setItem('job', JSON.stringify({ loading: false, data: null, error: error?.response }));
            showToast('Got an issue while downloading PDF. Please try again.', 'error');
            return error?.response;
        }
    };
};


export const AddPatientVialsPack = (type, formdata, id, setShowModal, setShowToast) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {
            const requestData = {
                patient_id: id,
                recurrence_day_type: formdata.recurrence_day_type,
                recurrence_day: formdata.recurrence_day_type === 'custom' ? formdata.r_days : formdata.recurrence_day,
                rx_need_to_bill: formdata.rx_need_to_bill,
                deductibles: formdata.deductibles,
                note: formdata.note,
                recurrence_weekday: formdata.vialsweekday,
                start_date: formdata.date,
                facility: formdata.facility
            }

            const response = await Axios.post(`${add_vials_pack}`, requestData)
            if (response?.status === 200) {

                dispatch(addPatientBlisterPackSuccess(response?.data, type))

                if (typeof setShowModal === 'function') {
                    setShowModal((prevStat) => ({ ...prevStat, addBlisterPackModal: false }))
                    document.body.style.overflow = 'auto'
                }

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, showToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, showToast: false }))
                    }, 2000);
                }

            } else {
                throw new Error(response)
            }

        } catch (error) {
            if (error?.response) {

                const errorMessage = error?.response?.data?.data?.error === 'This patient entry has reached the allowed limit.'
                if (errorMessage) {
                    toast.error('2 packs are already added for this patient. Please contact admin.')
                }

                else if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, errorToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, errorToast: false }))
                    }, 2000);
                }

                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}

export const UpdateVialsPack = (type, formdata, id, setShowModal, setShowToast, paginationNumber) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {
            const requestData = {
                pack_id: id,
                vials_route: formdata.route,
                facility: formdata.facility,
                deductible: formdata.deductible,
                rx_need_to_bill: formdata.no_of_rx_need_to_bill,
                note: formdata.note,
                date: formdata.processingDate
            }

            const response = await Axios.post(`${update_vials_pack}`, requestData)

            if (response?.status === 200) {

                dispatch(addPatientBlisterPackSuccess(response?.data, type))

                if (typeof setShowModal === 'function') {
                    setShowModal((prevStat) => ({ ...prevStat, updateBlisterlist: false }))
                    document.body.style.overflow = 'auto'
                }

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, showToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, showToast: false }))
                    }, 2000);
                }

                const params = {
                    page: paginationNumber,
                    no_of_records: 10
                }

                dispatch(fetchBlisterPacksList('Vials_pack_list', params, path.vials_patient_pack))

            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, errorToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, errorToast: false }))
                    }, 2000);
                }

                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}


export const UpdateDailyVailsPack = (type,
    requestData,
    setShowModal,
    setShowToast,
    paginationNumber,
    fetchType,
    billedType,
    filterParam,
    filterData) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {

            const response = await Axios.post(`${update_vials_packlogs}`, requestData)

            if (response?.status === 200) {
                dispatch(addPatientBlisterPackSuccess(response?.data, type))

                if (typeof setShowModal === 'function') {
                    setShowModal((prevStat) => ({ ...prevStat, updateBlisterlist: false }))
                    document.body.style.overflow = 'auto'
                }

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, showToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, showToast: false }))
                    }, 2000);
                }

                const params = {
                    no_of_records: 25,
                    page: paginationNumber,
                    // ...filterParam
                    ...(filterParam && typeof filterParam === 'object' ? filterParam : {}) // Safe spread
                };

                // if (filterData.route) params.route = filterData.route;
                // if (filterData.search) params.search = filterData.search;
                // if (filterData.day) params.rec_day = filterData.day.match(/\d+/)[0];
                // if (filterData.weekday) params.rec_weekday = filterData.weekday;
                // if (filterData.facility) params.facility = filterData.facility;
                // if (filterData.startDate) params.from_date = filterData.startDate;
                // if (filterData.endDate) params.to_date = filterData.endDate;
                // if (billedType) params.billed = billedType;

                if (fetchType === 'due_date') dispatch(fetchVialsDailyPackList('vials_daily_pack_list', params))

            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, errorToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, errorToast: false }))
                    }, 2000);
                }

                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}


// ----------------------------------------------------Add Medication Start ---------------------------------------


export const AddPatientMedicationPack = (type, formdata, id, setShowModal, setShowToast) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {
            const requestData = {
                patient_id: id,
                recurrence_day_type: formdata.recurrence_day_type,
                recurrence_day: formdata.recurrence_day_type === 'custom' ? formdata.r_days : formdata.recurrence_day,
                rx_need_to_bill: formdata.rx_need_to_bill,
                deductibles: formdata.deductibles,
                note: formdata.note,
                recurrence_weekday: formdata.recurrence_weekday,
                facility: formdata.facility
            }

            const response = await Axios.post(`${add_sMedication_pack}`, requestData)
            if (response?.status === 200) {

                dispatch(addPatientBlisterPackSuccess(response?.data, type))

                if (typeof setShowModal === 'function') {
                    setShowModal((prevStat) => ({ ...prevStat, addBlisterPackModal: false }))
                    document.body.style.overflow = 'auto'
                }

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, showToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, showToast: false }))
                    }, 2000);
                }

            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {

                const errorMessage = error?.response?.data?.data?.error === 'This patient entry has reached the allowed limit.'

                if (errorMessage) {
                    toast.error('2 packs are already added for this patient. Please contact admin.')
                }

                else if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, errorToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, errorToast: false }))
                    }, 2000);
                }

                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}


export const UpdateMedicationPack = (type, requestData, setShowModal, setShowToast, paginationNumber, fetchType, filterParam) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {
            const response = await Axios.post(`${update_sMedication_pack}`, requestData)

            if (response?.status === 200) {

                dispatch(addPatientBlisterPackSuccess(response?.data, type))

                if (typeof setShowModal === 'function') {
                    setShowModal((prevStat) => ({ ...prevStat, updateBlisterlist: false }))
                    document.body.style.overflow = 'auto'
                }

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, showToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, showToast: false }))
                    }, 2000);
                }

                const params = {
                    page: paginationNumber,
                    no_of_records: 25,
                    ...filterParam
                }

                if (fetchType === 'processing_date') dispatch(fetchBlisterPacksList('medication_pack_list', params, path.sMedication_pack_list))

            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, errorToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, errorToast: false }))
                    }, 2000);
                }

                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}

export const UpdateDailyMedicationPack = (type, requestData, setShowModal, setShowToast, paginationNumber, fetchType, filterParam) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {

            const response = await Axios.post(`${update_sMedication_log}`, requestData)

            if (response?.status === 200) {
                dispatch(addPatientBlisterPackSuccess(response?.data, type))

                if (typeof setShowModal === 'function') {
                    setShowModal((prevStat) => ({ ...prevStat, updateBlisterlist: false }))
                    document.body.style.overflow = 'auto'
                }

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, showToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, showToast: false }))
                    }, 2000);
                }

                const params = {
                    page: paginationNumber,
                    no_of_records: 25,
                    // ...filterParam
                    ...(filterParam && typeof filterParam === 'object' ? filterParam : {}) // Safe spread
                }

                if (fetchType === 'due_date') dispatch(fetchMEdicationDailyPackList('medication_daily_pack_list', params))

            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, errorToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, errorToast: false }))
                    }, 2000);
                }

                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}


export const UpdateVialsSingleData = (type, formdata, id, setShowModal, setShowToast, paginationNumber, filterParam) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {
            //console.log("bohemia"+filterParam)
            let requestData = {
                pack_id: id,
                vials_route: formdata.route,
                facility: formdata.facility,
                deductible: formdata.deductible,
                rx_need_to_bill: formdata.rx_need_to_bill,
                note: formdata.note,
                date: formdata.date,
            }
            const response = await Axios.post(`update-vials-pack`, requestData)

            if (response?.status === 200) {
                dispatch(addPatientBlisterPackSuccess(response?.data, type))

                if (typeof setShowModal === 'function') {
                    setShowModal((prevStat) => ({ ...prevStat, updateBlisterlist: false }))
                    document.body.style.overflow = 'auto'
                }

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, showToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, showToast: false }))
                    }, 2000);
                }

                const params = {
                    page: paginationNumber,
                    no_of_records: 25,
                    ...filterParam
                }


                // dispatch(fetchBlisterPacksList('Vials_pack_list', params, path.vials_patient_pack))

            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {

                if (typeof setShowToast === 'function') {
                    setShowToast((prevStat) => ({ ...prevStat, errorToast: true }))
                    setTimeout(() => {
                        setShowToast((prevStat) => ({ ...prevStat, errorToast: false }))
                    }, 2000);
                }

                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}

export const HandleUpdateVialsPack = (type, requestData, url) => {

    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {
            const response = await Axios.post(url ? url : `update-vials-pack`, requestData)

            if (response?.status === 200) {
                dispatch(addPatientBlisterPackSuccess(response?.data, type))

            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}


export const PharmacyAddBlisterPackOnShelf = (type, id) => {
    return async (dispatch) => {
        dispatch(addPatientBlisterPackRequest(type))
        try {
            const response = await Axios.post(`pharmacy-patient-blisterPack/restore-onshelf/${id}`)

            if (response?.status === 200) {
                const params = {
                    page: 1,
                    no_of_records: 25
                }
                dispatch(addPatientBlisterPackSuccess(response?.data, type))

                dispatch(fetchBlisterPacksList('blister_packs_list', params))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(addPatientBlisterPackFailure(error?.response, type))
            }
        }
    }
}